// this file is automatically generated by git.version.ts script
export const versions = { revision: '13549cf3d4785455a6dbaa01acd94a8b19772108', version: '12.48.0', updatedAt: '1738423040625' };